import { render, staticRenderFns } from "./ProductListingRelated.vue?vue&type=template&id=ae5a0d64&scoped=true&"
import script from "./ProductListingRelated.vue?vue&type=script&async=true&lang=js&"
export * from "./ProductListingRelated.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ProductListingRelated.vue?vue&type=style&index=0&id=ae5a0d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5a0d64",
  null
  
)

export default component.exports